import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Brand from "../assets/Shoora.svg";
import BrandWhite from "../assets/11.png";
import BrandDark from "../assets/9.png";
import BlogCardSmall from "../components/Card/BlogCardSmall";
import { useModal } from "../context/ModalContext";

const blogs = [
  {
    image: "/images/thumbnails/14.jpeg", // Replace with actual image URL
    title: "Envisioning the Future of Mobility with Shoora",
    link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
  },
  {
    image:
      "https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600", // Replace with actual image URL
    title: "Truck Driver Safety Tips: A Guide to Protecting Lives on the Road",
    link: "/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road",
  },
  {
    image:
      "https://images.pexels.com/photos/11389692/pexels-photo-11389692.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2", // Replace with actual image URL
    title: "Complimenting Fleet Modernization with Road Safety",
    link: "/insights/blog/complimenting-fleet-modernization-with-road-safety",
  },
];

const Navbar = ({ theme, styles }) => {
  const [isShowMobileMenu, setIsShowMobileMenu] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [isSubMenuOpenInsights, setIsSubMenuOpenInsights] = useState(false);
  const [isSubMenuOpenWhoWeAre, setIsSubMenuOpenWhoWeAre] = useState(false);
  const navigate = useNavigate();
  const { openModal } = useModal();

  const toggleSubMenu = (menu) => {
    setIsSubMenuOpen(!isSubMenuOpen);
    switch (menu) {
      case "insights":
        setIsSubMenuOpenInsights(!isSubMenuOpenInsights);
        setIsSubMenuOpen(false);
        setIsSubMenuOpenWhoWeAre(false);
        break;
      case "whoWeAre":
        setIsSubMenuOpenWhoWeAre(!isSubMenuOpenWhoWeAre);
        setIsSubMenuOpen(false);
        setIsSubMenuOpenInsights(false);
        break;
      case "solutions":
        setIsSubMenuOpen(!isSubMenuOpen);
        setIsSubMenuOpenWhoWeAre(false);
        setIsSubMenuOpenInsights(false);
        break;
      default:
        setIsSubMenuOpen(false);
        setIsSubMenuOpenInsights(false);
        setIsSubMenuOpenWhoWeAre(false);
        break;
    }
  };

  const toggleMobileMenu = () => {
    setIsShowMobileMenu(!isShowMobileMenu);
  };

  const subMenuItems = [
    {
      id: 0,
      title: "CabIn Vision",
      link: "/solutions/cabin-vision",
    },
    {
      id: 1,
      title: "CabIn Alerts",
      link: "/solutions/cabin-alerts",
    },
    {
      id: 2,
      title: "Road Sense",
      link: "/solutions/road-sense",
    },
    {
      id: 3,
      title: "Fleet Sense",
      link: "/solutions/fleet-sense",
    },
    {
      id: 4,
      title: "Happy Driver Programme",
      link: "/solutions/happy-driver-programme",
    },
    {
      id: 5,
      title: "Shoora Life Savers",
      link: "/solutions/shoora-life-savers",
    },
    {
      id: 6,
      title: "Marut Insights",
      link: "/solutions/marut-insights",
    },
    {
      id: 7,
      title: "All solutions",
      link: "/solutions",
    },
  ];
  const subMenuItemsWhoWeAre = [
    {
      id: 0,
      title: "About",
      link: "/about",
    },
    {
      id: 1,
      title: "Our Team",
      link: "/team",
    },
    {
      id: 2,
      title: "Our Values",
      link: "/about#values",
    },
    {
      id: 3,
      title: "Careers",
      link: "/careers",
    },
    // {
    //   id: 4,
    //   title: "Job Openings",
    //   link: "/jobs",
    // },
    // {
    //   id: 5,
    //   title: "My Applications",
    //   link: "/jobs/applications",
    // },
    {
      id: 6,
      title: "Events",
      link: "/events",
    },
    {
      id: 7,
      title: "Newsroom",
      link: "/newsroom",
    },
    {
      id: 8,
      title: "Contact Us",
      link: "/contact",
    },
    {
      id: 9,
      title: "Our Locations",
      link: "/contact",
    },
  ];
  const subMenuItemsInsights = [
    {
      id: 0,
      title: "Blogs",
      link: "/insights/blogs",
    },
    {
      id: 1,
      title: "Articles",
      link: "/insights/articles",
    },
    {
      id: 2,
      title: "Customer Stories",
      link: "/insights/customer-stories",
    },
    {
      id: 3,
      title: "Whitepapers",
      link: "/insights/whitepapers",
    },
    {
      id: 4,
      title: "All Insights",
      link: "/insights",
    },
    {
      id: 5,
      title: "Education & Training",
      link: "/education-and-training",
    },
    {
      id: 6,
      title: "CSR & ESG",
      link: "/csr-and-esg",
    },
    {
      id: 7,
      title: "Government Relations",
      link: "/government-relations",
    },
    {
      id: 8,
      title: "Developer APIs",
      link: "/developer-apis",
    },
    {
      id: 9,
      title: "FAQs",
      link: "/faqs",
    },
  ];

  return (
    <>
      <header style={{ zIndex: 100 }}>
        <div className="container">
          <nav className="navbar" style={{zIndex: 100}}>
            <div className="brand">
              <Link to="/">
                {/* <h1>shoora</h1> */}
                <img
                  src={theme === "light" ? BrandDark : BrandWhite}
                  alt="Shoora"
                  width={180}
                />
              </Link>
            </div>
            <div className="nav-links">
              <div className="main-navigation">
                <ul className="navigation-group">
                  <li className="navigation-item">
                    <Link
                      to="/solutions"
                      className="navigation-item-link"
                      style={
                        theme === "light"
                          ? styles?.light?.navigationItemLink
                          : {}
                      }
                    >
                      Solutions
                    </Link>
                    <div className="megamenu-dropdown">
                      <div className="container">
                        <div className="megamenu-group row row-cols-3 p-4">
                          <div className="megamenu-item col">
                            <a href="/solutions/cabin-vision">
                              <h3>
                                Cab
                                <span style={{ color: "var(--accent-color)" }}>
                                  In
                                </span>{" "}
                                <span style={{ fontWeight: 300 }}>Vision</span>
                                <sup
                                  style={{ fontWeight: 500, fontSize: "10px" }}
                                >
                                  TM
                                </sup>
                              </h3>
                              <p>
                                Improve safety and protect your fleet with
                                AI-driven risk detection and instant video
                                retrieval.
                              </p>
                            </a>
                          </div>
                          <div className="megamenu-item col">
                            <a href="/solutions/road-sense">
                              <h3>
                                <span className="fw-bold">Road</span>
                                <span style={{ color: "var(--accent-color)" }}>
                                  Sense
                                </span>

                                <sup
                                  style={{
                                    fontWeight: 500,
                                    fontSize: "10px",
                                    position: "relative",
                                  }}
                                >
                                  TM
                                </sup>
                              </h3>
                              <p>
                                Improve safety and protect your fleet with
                                AI-driven risk detection and instant video
                                retrieval.
                              </p>
                            </a>
                          </div>
                          <div className="megamenu-item col">
                            <a href="/solutions/cabin-alerts">
                              <h3>
                                Cab
                                <span style={{ color: "var(--accent-color)" }}>
                                  In
                                </span>{" "}
                                <span style={{ fontWeight: 300 }}>Alerts</span>
                                <sup
                                  style={{ fontWeight: 500, fontSize: "10px" }}
                                >
                                  TM
                                </sup>
                              </h3>
                              <p>
                                Boost safety and secure your fleet with
                                AI-driven risk detection and quick video
                                retrieval
                              </p>
                            </a>
                          </div>
                          <div className="megamenu-item col">
                            <a href={`/solutions/fleet-sense`}>
                              <h3>
                                Fleet
                                <span style={{ color: "var(--accent-color)" }}>
                                  Sense
                                </span>{" "}
                                <sup
                                  style={{ fontWeight: 500, fontSize: "10px" }}
                                >
                                  TM
                                </sup>
                              </h3>
                              <p>
                                Stay aware of operations—anytime, anywhere.
                                Receivein-app alerts for critical events
                              </p>
                            </a>
                          </div>
                          <div className="megamenu-item col">
                            <a href="/solutions/shoora-life-savers">
                              <h3>
                                <span style={{ color: "var(--accent-color)" }}>
                                  Shoora Life Savers
                                </span>{" "}
                              </h3>
                              <p>
                                A highly trained back-office team complements
                                ourSaaS platform.
                              </p>
                            </a>
                          </div>
                          <div className="megamenu-item col">
                            <a href="/solutions/happy-driver-programme">
                              <h3>
                                <span style={{ color: "var(--accent-color)" }}>
                                  Happy Driver
                                </span>{" "}
                                <span style={{ fontWeight: 300 }}>
                                  Programme
                                </span>
                              </h3>
                              <p>
                                Highly customizable e-modules to train drivers
                                for safety.
                              </p>
                            </a>
                          </div>
                          <div className="megamenu-item col">
                            <a href="/solutions/marut-insights">
                              <h3>
                                <span style={{ color: "var(--accent-color)" }}>
                                  Marut
                                </span>{" "}
                                <span style={{ fontWeight: 300 }}>
                                  Insights
                                </span>
                              </h3>
                              <p>Safety Initiative, top talents, excellence.</p>
                            </a>
                          </div>

                          <div className="megamenu-item col">
                            <a href="/solutions">
                              <h3>
                                Explore all solutions{" "}
                                <i class="fa-solid fa-arrow-right"></i>{" "}
                              </h3>
                            </a>
                            {/* <p>AI-Cameras, Driver coaching, Safety reports, In-cab alerts</p> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="navigation-item">
                    <Link
                      to="/insights"
                      className="navigation-item-link"
                      style={
                        theme === "light"
                          ? styles?.light?.navigationItemLink
                          : {}
                      }
                    >
                      Insights
                    </Link>
                    <div className="megamenu-dropdown who-we-are">
                      <div className="container">
                        <div className="row">
                          
                          <div className="col col-lg-4  p-3 sec-1 megamenu-group flex-column justify-content-between">
                            {[
                               {
                                link: "/insights/blogs",
                                text: "Blogs",
                                bg: "https://images.pexels.com/photos/1370295/pexels-photo-1370295.jpeg?auto=compress&cs=tinysrgb&w=600",
                              },
                              
                              {
                                link: "/insights/articles",
                                text: "Articles",
                                bg: "https://images.pexels.com/photos/1370295/pexels-photo-1370295.jpeg?auto=compress&cs=tinysrgb&w=600",
                              },
                              {
                                link: "/insights/customer-stories",
                                text: "Customer Stories",
                                bg: "https://images.pexels.com/photos/1370295/pexels-photo-1370295.jpeg?auto=compress&cs=tinysrgb&w=600",
                              },
                              {
                                link: "/insights/whitepapers",
                                text: "Whitepapers",
                                bg: "https://images.pexels.com/photos/1370295/pexels-photo-1370295.jpeg?auto=compress&cs=tinysrgb&w=600",
                              },
                              {
                                link: "/education-and-training",
                                text: "Education and Training",
                                // bg: "https://images.pexels.com/photos/1454360/pexels-photo-1454360.jpeg?auto=compress&cs=tinysrgb&w=600",
                              },
                              {
                                link: "/csr-and-esg",
                                text: "CSR & ESG",
                                bg: "https://images.pexels.com/photos/625219/pexels-photo-625219.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
                              },
                              {
                                link: "/government-relations",
                                text: "Government Relations",
                                bg: "https://images.pexels.com/photos/764681/pexels-photo-764681.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
                              },
                              {
                                link: "/developer-apis",
                                text: "Developer API",
                                bg: "https://images.pexels.com/photos/356065/pexels-photo-356065.jpeg?auto=compress&cs=tinysrgb&w=600",
                              },
                              {
                                link: "/faqs",
                                text: "FAQs",
                                bg: "https://images.pexels.com/photos/1370295/pexels-photo-1370295.jpeg?auto=compress&cs=tinysrgb&w=600",
                              },
                             
                            ]?.map((item, index) => (
                              // <div
                              //   key={index}
                              //   className="megamenu-item important-link-item"
                              //   style={{
                              //     backgroundSize: "cover",
                              //     backgroundPosition: "center",
                              //     overflow: "hidden",
                              //   }}
                              // >
                              //   <h3 className="position-relative  m-0">
                              //     <Link
                              //       to={item.link}
                              //       className="stretched-link text-decoration-none text-dark"
                              //     >
                              //       {item.text}
                              //     </Link>
                              //   </h3>
                              // </div>
                              <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <h3>
                                <a href={item?.link}>{item?.text}</a>
                              </h3>
                            </div>
                            ))}
                          </div>

                          {/* <div className="col px-0 megamenu-group flex-column justify-content-start">
                            {blogs?.map((blog, index) => (
                              <BlogCardSmall
                                key={index}
                                image={blog.image}
                                title={blog.title}
                                link={blog.link}
                              />
                            ))}
                           
                          </div> */}

                          <div
                            className="col px-0 megamenu-group flex-column justify-content-end sec-3"
                            style={{
                              backgroundImage:
                                "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(https://images.pexels.com/photos/11389692/pexels-photo-11389692.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2)",
                              backgroundSize: "cover",
                              //  backgroundPosition: "center"
                            }}
                          >
                            <div
                              className="megamenu-item p-5"
                              style={{ maxWidth: "100%" }}
                            >
                              <h2 className="fw-light  text-light">
                                Article
                              </h2>
                              <h1 className="fs-2 text-light fw-semibold">
                              Complimenting Fleet Modernization with Road Safety
                              </h1>
                              <a
                                href="/insights/complimenting-fleet-modernization-with-road-safety-736404happy-driver-programme"
                                className="text-white"
                              >
                                Read More
                              </a>
                            </div>
                          </div>
                            <div
                              className="col px-0 megamenu-group flex-column justify-content-end sec-3"
                              style={{
                                backgroundImage:
                                  "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(https://shoora.coretechinfra.com/images/thumbnails/14.jpeg)",
                                backgroundSize: "cover",
                                 backgroundPosition: "center"
                              }}
                            >
                              <div
                                className="megamenu-item p-5"
                                style={{ maxWidth: "100%" }}
                              >
                                <h2 className="fw-light  text-light">
                                  Article
                                </h2>
                                <h1 className="fs-2 text-light fw-semibold">
                                Envisioning the Future of Mobility with Shoora
                                </h1>
                                <a
                                  href="/insights/envisioning-the-future-of-mobility-with-shoora-213854"
                                  className="text-white"
                                >
                                  Read More
                                </a>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="navigation-item">
                    <Link
                      to="#"
                      className="navigation-item-link"
                      style={
                        theme === "light"
                          ? styles?.light?.navigationItemLink
                          : {}
                      }
                    >
                      Who we are
                    </Link>
                    <div className="megamenu-dropdown who-we-are">
                      <div className="container">
                        <div className="row gap-0">
                          <div className="col px-0 megamenu-group flex-column justify-content-start sec-1">
                            <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <h3>
                                <a href="/about">About Us</a>
                              </h3>
                            </div>
                            <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <h3>
                                <a href="/team">Our Team</a>
                              </h3>
                            </div>
                            <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <h3>
                                <a href="/about#values">Our Values</a>
                              </h3>
                            </div>
                            <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <h3>
                                <a href="/careers">Careers</a>
                              </h3>
                            </div>
                            <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <h3>
                                <a href="/events">Events</a>
                              </h3>
                            </div>
                            {/* <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <h3>
                                <a href="#">Awards & Recognitions</a>
                              </h3>
                            </div> */}
                            <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <h3>
                                <a href="/newsroom">Newsroom</a>
                              </h3>
                            </div>
                            <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <h3>
                                <a href="/contact">Contact Us</a>
                              </h3>
                            </div>
                          </div>
                          <div className="col px-0 megamenu-group flex-column justify-content-start sec-2">
                            <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <p className="text-light fs-3">
                                {/* <a href="/contact">Our Locations</a> */}
                                Our Locations
                              </p>
                            </div>
                            <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <h3>
                                <a href="/contact">India</a>
                              </h3>
                            </div>
                            <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <h3>
                                <a href="/contact">Tanzania</a>
                              </h3>
                            </div>
                            <div
                              className="megamenu-item"
                              style={{ maxWidth: "100%" }}
                            >
                              <h3>
                                <a href="/contact">Dubai</a>
                              </h3>
                            </div>
                            <div
                              className="megamenu-item-cta"
                              style={{ maxWidth: "100%" }}
                            >
                              <img
                                src="https://images.pexels.com/photos/244822/pexels-photo-244822.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                                alt=""
                                className="w-100"
                              />
                            </div>
                          </div>
                          <div
                            className="col px-0 megamenu-group flex-column justify-content-end sec-3"
                            style={{
                              backgroundImage:
                                "url(/images/hero/happy-driver-2.webp)",
                              backgroundSize: "cover",
                              backgroundPosition: "center"
                            }}
                          >
                            <div
                              className="megamenu-item p-5"
                              style={{ maxWidth: "100%" }}
                            >
                              <h2 className="fw-light  text-light">
                                Enroll in{" "}
                              </h2>
                              <h1 className="display-5 text-light fw-semibold">
                                HappyDriver{" "}
                                <i className="fw-light">Programme</i>
                              </h1>
                              <a
                                to="/solutions/happy-driver-programme"
                                className="text-white"
                              >
                                Learn More
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="navigation-item">
                    <Link
                      to="/contact"
                      className="navigation-item-link"
                      style={
                        theme === "light"
                          ? styles?.light?.navigationItemLink
                          : {}
                      }
                    >
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="navbar-cta">
              <div className="lets-talk-btn">
                <Link
                  className="cmp-button"
                  style={theme === "light" ? styles?.light?.cmpButton : {}}
                  onClick={openModal}
                >
                  Let's talk
                </Link>
              </div>
              <div className="search-btn">
                <button
                  className="cmp-button"
                  style={theme === "light" ? styles?.light?.cmpButton : {}}
                >
                  <i class="fa-solid fa-magnifying-glass"></i>
                </button>
              </div>
              {/* <div className="language-nav">
                <div
                  className="lang-nav-header"
                  style={theme === "light" ? styles?.light?.langNavHeader : {}}
                >
                  <div className="lang-nav-toggle">
                    <button
                      style={theme === "light" ? styles?.light?.cmpButton : {}}
                    >
                      <i
                        class="fa-solid fa-earth-americas"
                        style={
                          theme === "light" ? styles?.light?.cmpButton : {}
                        }
                      ></i>
                    </button>
                  </div>
                </div>
              </div> */}
              <div className="menu-nav">
                <div className="menu-nav-header">
                  <div className="menu-nav-toggle">
                    <button onClick={toggleMobileMenu}>
                      <i class="fa-solid fa-bars"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
        {isShowMobileMenu && (
          <div className="mobile-menu">
            <div className="container">
              <nav className="navbar">
                <div className="brand">
                  {/* <h1>shoora</h1> */}
                  <img src={BrandWhite} alt="Shoora" width={130} />
                </div>

                <div className="navbar-cta">
                  <div className="search-btn">
                    <button
                      className="cmp-button"
                      style={theme === "light" ? styles?.light?.cmpButton : {}}
                    >
                      <i class="fa-solid fa-earth-americas"></i>
                    </button>
                  </div>

                  <div className="menu-nav">
                    <div className="menu-nav-header">
                      <div className="menu-nav-toggle">
                        <button onClick={toggleMobileMenu}>
                          <i
                            class="fa-solid fa-xmark"
                            style={{ fontSize: "2rem" }}
                          ></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
              <div className="mobile-menu-container">
                <ul class="menu-items">
                  <li>
                    <a href="#" onClick={() => toggleSubMenu("solutions")}>
                      Solutions
                      <i className="fa-solid fa-angle-down"></i>
                    </a>
                    {subMenuItems && (
                      <ul className={`submenu ${isSubMenuOpen ? "open" : ""}`}>
                        {subMenuItems?.map((item) => (
                          <li key={item.id}>
                            <a href={item?.link}>{item.title}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>

                  <li>
                    <a href="#" onClick={() => toggleSubMenu("insights")}>
                      Insights <i class="fa-solid fa-angle-down"></i>
                    </a>
                    {subMenuItemsInsights && (
                      <ul
                        className={`submenu ${
                          isSubMenuOpenInsights ? "open" : ""
                        }`}
                      >
                        {subMenuItemsInsights?.map((item) => (
                          <li key={item.id}>
                            <a href={item?.link}>{item.title}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                  <li>
                    <a href="#" onClick={() => toggleSubMenu("whoWeAre")}>
                      Who We Are <i class="fa-solid fa-angle-down"></i>
                    </a>
                    {subMenuItemsWhoWeAre && (
                      <ul
                        className={`submenu ${
                          isSubMenuOpenWhoWeAre ? "open" : ""
                        }`}
                      >
                        {subMenuItemsWhoWeAre?.map((item) => (
                          <li key={item.id}>
                            <a href={item?.link}>{item.title}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                  <li>
                    <a href="#">
                      Contact <i class="fa-solid "></i>
                    </a>
                  </li>
                </ul>
                <button class="letstalk" onClick={openModal}>
                  Let's Talk
                </button>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Navbar;
